import { RouteConfig } from 'vue-router';
import { tabRoutes } from '@/common/RouteUtils';

const entityTypes = ['water_meters', 'water_tanks', 'water_monitors'] as const;
export type WaterEntityType = typeof entityTypes[number];

export function isWaterEntityType(value: string): value is WaterEntityType {
	return entityTypes.some(type => type === value);
}

const productTabs = [
	'general/information',
	'general/change-log',
	'general/billing-change-log',
	'partner-orgs',
	'transceivers',
	'map',
	'consent',
	'users',
	'faults',
	'simpro-jobs',
	'repair-job-texts',
	'sms-charges/current',
	'sms-charges/history',
];

const entityTabs = [
	'general/information',
	'general/change-log',
	'charts',
	'alerts/manage',
	'alerts/subscriptions',
	'alerts/deleted-subscriptions',
	'alerts/change-log',
	'alerts/sent',
];

export const waterProductRoutes: RouteConfig[] = [
	{
		path: '/account/products/water/:productId',
		name: 'products.water.view',
		component: () => import(/* webpackChunkName: "account" */ './view.vue'),
		meta: { auth: true },
		redirect: { name: 'products.water.general.information' },
		children: [
			...tabRoutes('products.water', productTabs),
			...entityTypes.map(entityType => {
				const prefix = `products.water.${entityType}`;
				const meta = { auth: true, entityType };
				const tabs = entityType === 'water_tanks' ? entityTabs : [...entityTabs, 'corrections'];
				return {
					path: entityType,
					name: prefix,
					meta,
					redirect: { name: `${prefix}.overview` },
					children: [
						{ path: 'overview', name: `${prefix}.overview`, meta },
						{
							path: ':entityId',
							name: `${prefix}.detail`,
							meta,
							redirect: { name: `${prefix}.detail.charts` },
							children: tabRoutes(`${prefix}.detail`, tabs, meta),
						},
					],
				};
			}),
		],
	},
	{
		path:
			'/account/products/water/:productId/:entityType(water_meters|water_tanks|water_monitors|waterMeters|waterTanks|waterMonitors)/:entityId',
		name: 'products.water.entity.view',
		meta: { auth: true },
		redirect: route => ({
			name: `products.water.${route.params.entityType.replace(
				/[A-Z]/g,
				letter => `_${letter.toLowerCase()}`,
			)}.detail.charts`,
			params: { productId: route.params.productId, entityId: route.params.entityId },
			query: route.query,
			hash: route.hash,
		}),
	},
];
